import { Injectable, inject, signal } from "@angular/core"
import { NavigationEnd, Router } from "@angular/router"
import { filter } from "rxjs"
import { EntityFilterService } from "../../core/services/entity-filter.service"

export interface PageContext {
  route: string
  entityId: string | null
  description: string
}

const ROUTE_DESCRIPTIONS: Record<string, string> = {
  "/transactions": "Transactions list",
  "/invoices": "Invoices list",
  "/reports": "Financial reports",
  "/loans": "Loans overview",
  "/mandates": "Direct debit mandates",
  "/documents": "Documents inbox",
  "/institutes": "Bank connections",
}

@Injectable({ providedIn: "root" })
export class ChatContextService {
  private router = inject(Router)
  private entityFilter = inject(EntityFilterService)

  readonly context = signal<PageContext>({
    route: "",
    entityId: null,
    description: "",
  })

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.updateContext(e.urlAfterRedirects))

    // Also update when entity changes
    this.updateContext(this.router.url)
  }

  private updateContext(url: string): void {
    const route = url.split("?")[0]
    const entityIds = this.entityFilter.getSelectedEntityIds()
    const entityId = entityIds.length === 1 ? entityIds[0] : null

    let description = ""
    for (const [prefix, desc] of Object.entries(ROUTE_DESCRIPTIONS)) {
      if (route.startsWith(prefix)) {
        description = desc
        break
      }
    }
    if (!description) description = `Page: ${route}`

    this.context.set({ route, entityId, description })
  }
}
